/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Argon Dashboard 2 MUI Base Styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import boxShadows from "assets/theme/base/boxShadows";

// Argon Dashboard 2 MUI Helper Functions
import pxToRem from "assets/theme/functions/pxToRem";

const { primary, light, info, secondary, warning, error, success, transparent } = colors;
const { size } = typography;
const { buttonBoxShadow } = boxShadows;

const outlined = {
    base: {
        minHeight: pxToRem(42),
        // color: light.main,
        borderColor: light.main,
        padding: `${pxToRem(10)} ${pxToRem(20)}`,

        "&:hover": {
            opacity: 0.75,
            backgroundColor: transparent.main,
        },

        "&:focus:not(:hover)": {
            boxShadow: buttonBoxShadow.stateOfNotHover,
        },

        "& .material-icon, .material-icons-round, svg": {
            fontSize: `${pxToRem(16)} !important`,
        },
    },

    small: {
        minHeight: pxToRem(34),
        padding: `${pxToRem(8)} ${pxToRem(32)}`,
        fontSize: size.xs,

        "& .material-icon, .material-icons-round, svg": {
            fontSize: `${pxToRem(12)} !important`,
        },
    },

    large: {
        minHeight: pxToRem(49),
        padding: `${pxToRem(14)} ${pxToRem(64)}`,
        fontSize: size.sm,

        "& .material-icon, .material-icons-round, svg": {
            fontSize: `${pxToRem(22)} !important`,
        },
    },

    primary: {
        backgroundColor: transparent.main,
        borderColor: primary.main,

        "&:hover": {
            backgroundColor: transparent.main,
        },

        "&:focus:not(:hover)": {
            boxShadow: buttonBoxShadow.stateOfNotHover,
        },
    },

    secondary: {
        backgroundColor: transparent.main,
        borderColor: secondary.main,

        "&:hover": {
            backgroundColor: transparent.main,
        },

        "&:focus:not(:hover)": {
            boxShadow: buttonBoxShadow.stateOfNotHover,
        },
    },

    error: {
        backgroundColor: transparent.main,
        borderColor: error.main,
        color: error.main,

        "&:hover": {
            backgroundColor: transparent.main,
        },

        "&:focus:not(:hover)": {
            boxShadow: buttonBoxShadow.stateOfNotHover,
        },
    },

    warning: {
        backgroundColor: transparent.main,
        borderColor: warning.main,
        color: warning.main,

        "&:hover": {
            backgroundColor: transparent.main,
        },

        "&:focus:not(:hover)": {
            boxShadow: buttonBoxShadow.stateOfNotHover,
        },
    },
    
    info: {
        backgroundColor: transparent.main,
        borderColor: info.main,
        color: info.main,

        "&:hover": {
            backgroundColor: transparent.main,
        },

        "&:focus:not(:hover)": {
            boxShadow: buttonBoxShadow.stateOfNotHover,
        },
    },
    
    success: {
        backgroundColor: transparent.main,
        borderColor: success.main,
        color: success.main,

        "&:hover": {
            backgroundColor: transparent.main,
        },

        "&:focus:not(:hover)": {
            boxShadow: buttonBoxShadow.stateOfNotHover,
        },
    },
};

export default outlined;
